import { Component, CUSTOM_ELEMENTS_SCHEMA, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { UserApiService } from 'src/app/services/user-api/user-api.service';
import { LoginService } from 'src/app/services/security/login.service';
import { environment } from 'src/environments/environment';
import { map } from 'rxjs';

@Component({
  selector: 'app-select-entitlement-group',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './select-entitlement-group.component.html',
  styleUrl: './select-entitlement-group.component.scss',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class SelectEntitlementGroupComponent implements OnInit {
  selectedFirm: string | null = null;
  firmOptions: { text: string; value: string }[] = [];
  isLoading = false;

  constructor(
    private readonly userApiService: UserApiService,
    private readonly loginService: LoginService,
  ) {}

  ngOnInit(): void {
    this.getUserEntitlements();
  }

  getUserEntitlements(): void {
    this.isLoading = true;
    this.userApiService
      .getEntitlements()
      .pipe(
        map((response) =>
          response.map((entitlement) => entitlement.group).sort(),
        ),
      )
      .subscribe({
        next: (groups: string[]) => {
          this.isLoading = false;
          this.firmOptions = [
            { text: 'Select Item...', value: '' },
            ...groups.map((group) => ({
              text: group,
              value: group,
            })),
          ];
        },
      });
  }

  onFirmChange(event: Event): void {
    this.selectedFirm =
      (event as CustomEvent).detail?.value ??
      (event.target as HTMLSelectElement).value;
  }

  onContinue(): void {
    this.isLoading = true;
    if (!this.selectedFirm) return;
    this.loginService.login(this.selectedFirm).subscribe({
      next: (success) => {
        if (success) {
          this.location.assign(environment.loginRedirectPath);
        }
      },
      error: () => {
        this.isLoading = false;
      },
    });
  }

  private get location(): Location {
    return window.location;
  }
}
